"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.hasThumbnail = hasThumbnail;
var React = _interopRequireWildcard(require("react"));
var _overrides = require("../helpers/overrides");
var _heading = require("../heading");
var _styledComponents = require("./styled-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
function hasThumbnail(props) {
  return !!props.thumbnail;
}

// @ts-ignore
const SemanticTitle = ({
  children,
  ...restProps
}) => {
  const levels = ['', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
  return /*#__PURE__*/React.createElement(_heading.LevelContext.Consumer, null, level =>
  /*#__PURE__*/
  // @ts-expect-error
  React.createElement(_styledComponents.Title, _extends({
    $as: levels[level]
  }, restProps), children));
};
function Card(props) {
  const {
    action,
    children,
    hasThumbnail,
    headerImage,
    thumbnail: thumbnailSrc,
    title,
    overrides,
    ...restProps
  } = props;
  const {
    Action: ActionOverride,
    Body: BodyOverride,
    Contents: ContentsOverride,
    HeaderImage: HeaderImageOverride,
    Root: RootOverride,
    Thumbnail: ThumbnailOverride,
    Title: TitleOverride
  } = overrides;
  const Action = (0, _overrides.getOverride)(ActionOverride) || _styledComponents.Action;
  const Body = (0, _overrides.getOverride)(BodyOverride) || _styledComponents.Body;
  const Contents = (0, _overrides.getOverride)(ContentsOverride) || _styledComponents.Contents;
  const HeaderImage = (0, _overrides.getOverride)(HeaderImageOverride) || _styledComponents.HeaderImage;
  const Root = (0, _overrides.getOverride)(RootOverride) || _styledComponents.Root;
  const Thumbnail = (0, _overrides.getOverride)(ThumbnailOverride) || _styledComponents.Thumbnail;
  const Title = (0, _overrides.getOverride)(TitleOverride) || SemanticTitle;
  const headerImageProps = typeof headerImage === 'string' ? {
    src: headerImage
  } : headerImage;

  // @ts-ignore
  const $hasThumbnail = hasThumbnail(props);
  return /*#__PURE__*/React.createElement(Root, _extends({
    "data-baseweb": "card"
  }, restProps, (0, _overrides.getOverrideProps)(RootOverride)), headerImage && /*#__PURE__*/React.createElement(HeaderImage, _extends({}, headerImageProps, (0, _overrides.getOverrideProps)(HeaderImageOverride))), /*#__PURE__*/React.createElement(Contents, (0, _overrides.getOverrideProps)(ContentsOverride), thumbnailSrc && /*#__PURE__*/React.createElement(Thumbnail, _extends({
    src: thumbnailSrc
  }, (0, _overrides.getOverrideProps)(ThumbnailOverride))), title && /*#__PURE__*/React.createElement(Title, _extends({
    $hasThumbnail: $hasThumbnail
  }, (0, _overrides.getOverrideProps)(TitleOverride)), title), /*#__PURE__*/React.createElement(Body, (0, _overrides.getOverrideProps)(BodyOverride), children), action && /*#__PURE__*/React.createElement(Action, (0, _overrides.getOverrideProps)(ActionOverride), action)));
}
Card.defaultProps = {
  action: null,
  children: null,
  hasThumbnail,
  overrides: {}
};
var _default = exports.default = Card;